import { Observable, OperatorFunction } from "rxjs";
import { ChangeDetectorRef } from "@angular/core";
import { detached } from "./fn/detached-fn";

export function runDetached<T>(ref: { cd: ChangeDetectorRef }): OperatorFunction<T, T> {
  return (source) => {
    return new Observable((observer) => {
      const onNext = (value: T) =>
        detached(ref, () => {
          observer.next(value);
        });
      const onError = (e: any) => () =>
        detached(ref, () => {
          observer.error(e);
        });
      const onComplete = () => () =>
        detached(ref, () => {
          observer.complete();
        });
      return source.subscribe({ next: onNext, error: onError, complete: onComplete });
    });
  };
}
